// extracted by mini-css-extract-plugin
export default {"filterBox":"SearchBox_filterBox__uwcRz","findText":"SearchBox_findText__6Lq-g","cancelButton":"SearchBox_cancelButton__EV9LI","input":"SearchBox_input__TSHS8"};